/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add anchorlines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noanchorline,.tile__link, .btn,.pagenav__anchor):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noanchorline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='anchorline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".anchorline").before(icon);
        } else {
          el.querySelector(".anchorline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - People accordion
    ========================================================================== */

const peopleAccordion = document.querySelectorAll(".people__accordion-heading");

const peopleAccordionInit = function (peopleAccordionItems) {
  if (!peopleAccordionItems) {
    return;
  }

  peopleAccordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".people__accordion").classList.toggle("people__accordion--open");
    })
  );
}; // peopleAccordionInit();
peopleAccordionInit(peopleAccordion);

const pageheaderVideos = document.querySelectorAll(".hero__video-video");

const responsiveVideoInit = function () {
  if (!pageheaderVideos.length) {
    return;
  }

  pageheaderVideos.forEach(video => {
    const source = video.querySelector("source");
    const desktopSrc = source.dataset.desktopSrc;
    const mobileSrc = source.dataset.mobileSrc;

    const isDesktop = window.innerWidth >= 700;
    const correctSrc = isDesktop ? desktopSrc : mobileSrc;

    // Replace src and reload video
    if (!source.src) {
      source.src = chosenSrc;
      video.load();
    }
  });
};

responsiveVideoInit(pageheaderVideos);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
		Check Scroll
		========================================================================== */
let oldScrollY = 0;

function checkScroll() {
  const navbar = document.querySelector(".navbar");
  if ($(window).scrollTop() > 20) {
    navbar.classList.add("navbar--scrolled");
  } else {
    navbar.classList.remove("navbar--scrolled");
  }
  oldScrollY = window.scrollY;
}

$(window).scroll(function () {
  checkScroll();
});

checkScroll();

/* ==========================================================================
   VCard Download
   ========================================================================== */

const vcardModules = document.querySelectorAll(".download-vcard");

const vcardInit = function () {
  if (!vcardModules.length) {
    return;
  }

  vcardModules.forEach(button => {
    button.addEventListener("click", () => {
      const rawData = button.getAttribute("data-vcard");
      if (!rawData) {
        return;
      }

      let data;
      try {
        data = JSON.parse(rawData);
      } catch (error) {
        console.error("[vcard] Invalid JSON", error);
        return;
      }

      const nameParts = data.name.trim().split(" ") || [];
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      const vcard = `
			BEGIN:VCARD
			VERSION:3.0
			N:${lastName};${firstName};;;
			FN:${data.name}
			ORG:Stevens \\& Bolton LLP
			TITLE:${data.role || ""}
			EMAIL;TYPE=INTERNET:${data.email || ""}
			TEL;TYPE=WORK,VOICE:${data.phone || ""}
			URL:${data.linkedin || ""}
			END:VCARD
			`.trim();

      const blob = new Blob([vcard], { type: "text/vcard" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${data.name?.replace(/\s+/g, "_") || "contact"}.vcf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  });
};

vcardInit();

/* ==========================================================================
  Predicted Search
   ========================================================================== */

// const searchInputField = document.querySelector(".searchform__input-field");

// const searchInputInit = function () {
//   if (!searchInputField) return;

//   const suggestionsBox = document.getElementById("suggestions");
//   const suggestionsWrapper = document.querySelector(".suggestions__wrapper");
//   const suggestionsViewMore = document.querySelector(".suggestions__viewmore");

//   searchInputField.addEventListener("keyup", function () {
//     const query = this.value.trim();

//     if (query.length < 2) {
//       suggestionsBox.innerHTML = "";
//       suggestionsWrapper.classList.add("suggestions__wrapper--active");
//       searchInputField.classList.remove("active");
//       return;
//     }

//     fetch(`/wp-admin/admin-ajax.php?action=live_search&term=${encodeURIComponent(query)}`)
//       .then(res => res.json())
//       .then(data => {
//         suggestionsBox.innerHTML = "";
//         let hasResults = false;

//         console.log(data);
//         // Create row + columns
//         const row = document.createElement("div");
//         row.className = "row";

//         const colPeople = document.createElement("div");
//         colPeople.className = "col col-1 col-md-1-2";

//         const colServices = document.createElement("div");
//         colServices.className = "col col-1 col-md-1-2";

//         // People
//         if (data.people && data.people.length > 0) {
//           hasResults = true;
//           const peopleList = document.createElement("ul");

//           const peopleHeading = document.createElement("div");
//           peopleHeading.innerHTML = `<strong class="">People</strong>`;
//           colPeople.appendChild(peopleHeading);

//           data.people.forEach(post => {
//             const li = document.createElement("li");
//             li.innerHTML = `<a href="${post.link}" class="line--added"><span class="anchorline">${post.title}<span></a>`;
//             peopleList.appendChild(li);
//           });

//           colPeople.appendChild(peopleList);
//         }

//         // Services
//         if (data.services && data.services.length > 0) {
//           hasResults = true;
//           const servicesList = document.createElement("ul");

//           const servicesHeading = document.createElement("div");
//           servicesHeading.innerHTML = `<strong class="">Services</strong>`;
//           colServices.appendChild(servicesHeading);

//           data.services.forEach(post => {
//             const li = document.createElement("li");
//             li.innerHTML = `<a href="${post.link}" class="line--added"><span class="anchorline">${post.title}<span></a>`;
//             servicesList.appendChild(li);
//           });

//           colServices.appendChild(servicesList);
//         }

//         // If any results, show them
//         if (hasResults) {
//           row.appendChild(colPeople);
//           row.appendChild(colServices);
//           suggestionsBox.appendChild(row);

//           suggestionsViewMore.innerHTML = `
// 						<a href="/?s=${encodeURIComponent(query)}" class="">
// 							View more results <i class="far fa-arrow-right"></i>
// 						</a>`;
//           suggestionsBox.appendChild(suggestionsViewMore);

//           suggestionsWrapper.classList.add("suggestions__wrapper--active");
//           searchInputField.classList.add("active");
//         } else {
//           suggestionsWrapper.classList.add("suggestions__wrapper--active");
//           searchInputField.classList.remove("active");
//         }
//       });
//   });

//   // Hide on click outside
//   document.addEventListener("click", function (e) {
//     if (!searchInputField.contains(e.target) && !suggestionsBox.contains(e.target)) {
//       suggestionsBox.innerHTML = "";
//       suggestionsWrapper.classList.add("suggestions__wrapper--active");
//       searchInputField.classList.remove("active");
//     }
//   });
// };

// searchInputInit();

/*  ==========================================================================
  Maps JS
		========================================================================== */

(function ($) {
  /*
   *  document ready
   *
   *  This function will render each map when the document is ready (page has loaded)
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	5.0.0
   *
   *  @param	n/a
   *  @return	n/a
   */
  // global var
  let map;
  /* jshint ignore:start */
  async function initMap() {
    // Request needed libraries.

    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const { LatLngBounds } = await google.maps.importLibrary("core");

    const maps = document.querySelectorAll(".map__container");

    const mapsInit = function (maps) {
      maps.forEach(function (single_map) {
        let acf_map = single_map.querySelector(".acf-map");

        // Get all markers on the page.
        const properties = [];
        var markers = single_map.querySelectorAll(".marker");

        markers.forEach(function (marker) {
          properties.push({
            position: {
              lat: parseFloat(marker.dataset.lat),
              lng: parseFloat(marker.dataset.lng)
            },
            title: marker.dataset.title,
            link: marker.dataset.link
          });
        });

        map = new Map(acf_map, {
          zoom: 17,
          center: new google.maps.LatLng(0, 0),
          mapId: "49c8595431056134e12ac649",
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          disableDefaultUI: true // a way to quickly hide all controls
        });

        // Go through Markers and set markers position and marker icon
        properties.forEach(property => {
          const markerImg = document.createElement("img");
          const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: property.position,
            content: buildContent(property)
          });

          AdvancedMarkerElement.addListener("click", () => {
            window.location.href = property.link;
          });
        });

        function buildContent(property) {
          const content = document.createElement("div");
          let src = php_variables.template_url + "/img/map-marker.png";
          content.classList.add("property");
          content.innerHTML = `
          					<div class="icon">
          							<img src="${src}" class="custom-marker"/>
          					</div>
          					`;
          return content;
        }

        // more then  1 marker?
        if (properties.length !== 1) {
          // This function will center the map, showing all markers attached to this map
          const bounds = new google.maps.LatLngBounds();
          // loop through all markers and create bounds
          $.each(properties, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat, marker.position.lng);
            bounds.extend(latlng);
          });
          // set center of map
          map.fitBounds(bounds);
        } else {
          map.setCenter(new google.maps.LatLng(properties[0].position.lat, properties[0].position.lng));
        }
      });
    };

    mapsInit(maps);
  }

  initMap();
  /* jshint ignore:end */

  window.onload = function () {
    const body = document.querySelector("body");
    body.classList.add("page__loaded");
  };
})(jQuery);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure anchorlines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init fades
        fadesInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll fades
    ========================================================================== */

const fades = document.querySelectorAll(".fade");

const fadesInit = function () {
  if (!fades) {
    return;
  }

  fades.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("fade--in");
        } else {
          val.classList.remove("fade--in");
        }
      },
      offset: "95%"
    });
  });
}; // fadesInit();
fadesInit();

/*  ==========================================================================
  Homepage rotation text
    ========================================================================== */

const rotationTextHeading = document.querySelector(".hero__rotationheading");

const headingRotationText = function (rotationTextHeading) {
  if (!rotationTextHeading) return;

  const rotationText = [...rotationTextHeading.querySelectorAll(".rotationtext")];
  let startTimestamp = null;

  // Find last text element and its end time
  const lastText = rotationText[rotationText.length - 1];
  const finalEnd = parseFloat(lastText.dataset.end);

  function updateRotation(currentTime) {
    if (!startTimestamp) startTimestamp = currentTime;

    const elapsed = (currentTime - startTimestamp) / 1000;

    // If we've passed the final end time → freeze the last text and STOP
    if (elapsed >= finalEnd) {
      rotationText.forEach(el => el.classList.remove("rotationtext--active"));
      lastText.classList.add("rotationtext--active");
      return; // <--- STOP LOOP FOREVER
    }

    // Normal rotation behavior
    rotationText.forEach(el => el.classList.remove("rotationtext--active"));

    const activeText = rotationText.find(el => {
      const start = parseFloat(el.dataset.start);
      const end = parseFloat(el.dataset.end);
      return elapsed >= start && elapsed < end;
    });

    if (activeText) {
      activeText.classList.add("rotationtext--active");
    }

    requestAnimationFrame(updateRotation);
  }

  requestAnimationFrame(updateRotation);
};

if (rotationTextHeading) {
  headingRotationText(rotationTextHeading);
}

/*  ==========================================================================
  Fullheight content
    ========================================================================== */

const fullheightContentItems = document.querySelectorAll(".fullheight-content");

const fullheightContentItemsInit = function () {
  if (!fullheightContentItems) {
    return;
  }

  fullheightContentItems.forEach(function (fullheightContentItem) {
    const navItems = fullheightContentItem.querySelectorAll(".fullheight__navigation li");
    const contentAreas = fullheightContentItem.querySelectorAll(".fullheight__content-area");
    const backgroundImage = fullheightContentItem.querySelector(".fullheight__img-overlay");

    navItems.forEach(item => {
      item.addEventListener("click", () => {
        const target = item.getAttribute("data-index");

        // Toggle active nav item
        navItems.forEach(nav => nav.classList.remove("active"));
        item.classList.add("active");

        // Show/Hide content areas
        contentAreas.forEach(content => {
          if (content.getAttribute("data-content") === target) {
            content.classList.add("active");

            // Update background color if data-bg is set
            const bgColor = content.getAttribute("data-bg");
            if (bgColor && backgroundImage) {
              // Remove any existing bg-* classes
              backgroundImage.classList.forEach(cls => {
                if (cls.startsWith("bg-")) {
                  backgroundImage.classList.remove(cls);
                }
              });

              // Add the new background class
              backgroundImage.classList.add("bg-" + bgColor);
            }
          } else {
            content.classList.remove("active");
          }
        });
      });
    });
  });
};
fullheightContentItemsInit();

/* ==========================================================================
   Image Accordions – Scroll-Triggered Activation
   ========================================================================== */

const imageAccordions = document.querySelectorAll(".image-accordion");

const imageAccordionsInit = function () {
  if (!imageAccordions.length) {
    return;
  }

  const activateAccordion = imageAccordion => {
    const imageSlides = imageAccordion.querySelectorAll(".imageaccordions");
    const textSlides = imageAccordion.querySelectorAll(".accordion__slide");
    const accordionsRow = imageAccordion.querySelector(".accordionsrow");

    if (!accordionsRow || !textSlides.length) {
      return;
    }
    // Only activate once
    if (accordionsRow.classList.contains("active")) {
      return;
    }

    accordionsRow.classList.add("active");

    const currentSlide = imageAccordion.querySelector(".accordion__slide.active");
    const newSlide = imageAccordion.querySelector('.accordion__slide[data-target="0"]');

    if (!newSlide || currentSlide === newSlide) {
      return;
    }

    if (currentSlide) {
      currentSlide.classList.remove("active");
      currentSlide.classList.add("exit-up");
      currentSlide.setAttribute("aria-hidden", "true");
    }

    newSlide.classList.add("active");

    setTimeout(() => {
      if (currentSlide) {
        currentSlide.classList.remove("exit-up");
        newSlide.setAttribute("aria-hidden", "false");
      }
    }, 500);
  };

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          activateAccordion(entry.target);
        }
      });
    },
    {
      root: null,
      threshold: 0.1, // Small value so it triggers early in the viewport
      rootMargin: "-10% 0px -80% 0px" // almost at top
    }
  );

  imageAccordions.forEach(accordion => {
    observer.observe(accordion);
  });
};

if (window.innerWidth > gridSizes.md) {
  imageAccordionsInit();
}

/* ==========================================================================
   Scroll Quotes Module (In-Place Slide Transition)
   ========================================================================== */

const scrollQuotesModules = document.querySelectorAll(".scroll-quotes");

const scrollQuotesInit = function () {
  if (!scrollQuotesModules.length) {
    return;
  }

  scrollQuotesModules.forEach(scrollModule => {
    const quotes = scrollModule.querySelectorAll(".quote");
    const numSlides = quotes.length;
    const quoteWrapper = scrollModule.querySelector(".quotes");

    const navbar = document.querySelector(".navbar__wrap");

    const setWrapperHeight = () => {
      const navbarHeight = navbar ? navbar.offsetHeight : 0;
      const vh = window.innerHeight;
      const totalHeight = numSlides * vh - navbarHeight;
      scrollModule.style.height = `${totalHeight}px`;
    };

    const handleScroll = () => {
      const rect = scrollModule.getBoundingClientRect();
      const scrollTop = window.scrollY || window.pageYOffset;
      const scrollOffset = scrollTop + rect.top;
      const progress = scrollTop - scrollOffset;
      const index = Math.round(progress / window.innerHeight);

      if (index >= 0 && index < numSlides) {
        quotes.forEach((quote, i) => {
          quote.classList.toggle("active", i === index);
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", () => {
      setWrapperHeight();
      handleScroll();
    });

    // Init
    setWrapperHeight();
    handleScroll();
  });
};

if (window.innerWidth > gridSizes.lg) {
  scrollQuotesInit();
}

/* ==========================================================================
   Experience Tabs
   ========================================================================== */

const experienceModules = document.querySelectorAll(".person__experience");

const experienceTabsInit = function () {
  if (!experienceModules.length) {
    return;
  }
  experienceModules.forEach(module => {
    const tabButtons = module.querySelectorAll(".experience__links li");
    const tabPanels = module.querySelectorAll(".experience__tab");

    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-target");

        // Toggle active button styles
        tabButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");

        // Toggle tab visibility
        tabPanels.forEach(panel => {
          const isMatch = panel.getAttribute("data-target") === target;
          panel.classList.toggle("active", isMatch);
          panel.setAttribute("aria-hidden", !isMatch);
        });
      });
    });
  });
};

experienceTabsInit();

/* ==========================================================================
   Tabbed Content
   ========================================================================== */

const tabbedContentModules = document.querySelectorAll(".tabbed-content");

const tabbedContentInit = function () {
  if (!tabbedContentModules.length) {
    return;
  }

  tabbedContentModules.forEach(module => {
    const tabs = module.querySelectorAll(".tabbedcontent__tabs li");
    const select = module.querySelector(".tabbedcontent__select");
    const panels = module.querySelectorAll(".tabbedcontent__panel");

    const activateTab = index => {
      tabs.forEach(tab => tab.classList.remove("active"));
      panels.forEach(panel => {
        const isActive = panel.dataset.panel === index;
        panel.classList.toggle("active", isActive);
        panel.setAttribute("aria-hidden", !isActive);
      });

      const activeTab = module.querySelector(`.tabbedcontent__tabs li[data-tab="${index}"]`);
      if (activeTab) {
        activeTab.classList.add("active");
      }
    };

    // Tab click
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        const index = tab.dataset.tab;
        activateTab(index);
        if (select) {
          select.value = index;
        }
      });
    });

    // Dropdown change
    if (select) {
      select.addEventListener("change", () => {
        const index = select.value;
        activateTab(index);
      });
    }
  });
};

tabbedContentInit();

/* ==========================================================================
   Tabbed Podcasts Content
   ========================================================================== */

const podcastsTabbedModules = document.querySelectorAll(".tabbed-podcasts");

const podcastsTabbedInit = function () {
  if (!podcastsTabbedModules.length) {
    return;
  }

  podcastsTabbedModules.forEach(module => {
    const tabs = module.querySelectorAll(".tabbedcontent__tabs li");
    const select = module.querySelector(".tabbedcontent__select");
    const panels = module.querySelectorAll(".tabbedcontent__panel");

    const activateTab = index => {
      tabs.forEach(tab => tab.classList.remove("active"));
      panels.forEach(panel => {
        const isActive = panel.dataset.panel === index;
        panel.classList.toggle("active", isActive);
        panel.setAttribute("aria-hidden", !isActive);
      });

      const activeTab = module.querySelector(`.tabbedcontent__tabs li[data-tab="${index}"]`);
      if (activeTab) {
        activeTab.classList.add("active");
      }
    };

    // Tab click
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        const index = tab.dataset.tab;
        activateTab(index);
        if (select) {
          select.value = index;
        }
      });
    });

    // Dropdown change
    if (select) {
      select.addEventListener("change", () => {
        const index = select.value;
        activateTab(index);
      });
    }
  });
};

podcastsTabbedInit();

/* ==========================================================================
   Tabbed Podcasts Content
   ========================================================================== */

const imageCols = document.querySelectorAll(".js-image-col");

const imageColsInit = function () {
  if (!imageCols.length) {
    return;
  }

  imageCols.forEach((col, i) => {
    const slides = col.querySelectorAll(".people__image-slide");
    if (slides.length <= 0) {
      return;
    }

    let index = 0;
    slides[index].classList.add("is-active");

    setTimeout(() => {
      setInterval(() => {
        slides[index].classList.remove("is-active");
        index = (index + 1) % slides.length;
        slides[index].classList.add("is-active");
      }, 7000);
    }, i * 450);
  });
};

imageColsInit();

/* ==========================================================================
   Services Accordion
   ========================================================================== */
const serviceGrid = document.querySelector(".services-grid");

const servicesInit = function () {
  if (!serviceGrid) {
    return;
  }

  const toggles = serviceGrid.querySelectorAll(".accordion__toggle");

  const closeAll = function () {
    toggles.forEach(toggle => toggle.classList.remove("open"));

    serviceGrid.querySelectorAll(".js-service__accordion").forEach(accordion => {
      accordion.classList.remove("is-open");
      accordion.innerHTML = "";
    });
  };

  const getAccordionTarget = function (card) {
    if (!card) {
      return null;
    }

    if (window.innerWidth >= gridSizes.lg) {
      return findAccordionAfterCard(card, ".show-desktop");
    }

    if (window.innerWidth >= gridSizes.md) {
      return findAccordionAfterCard(card, ".show-tablet");
    }

    return findAccordionAfterCard(card, ".show-mobile");
  };

  const injectChildren = function (card, accordionTarget) {
    if (!card || !accordionTarget) {
      return;
    }

    const template = card.querySelector(".js-service-children-template");

    if (!template) {
      return;
    }

    accordionTarget.innerHTML = "";
    accordionTarget.appendChild(template.content.cloneNode(true));
    accordionTarget.classList.add("is-open");
  };

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      const isOpen = this.classList.contains("open");
      const card = this.closest(".service__card");

      closeAll();

      if (isOpen || !card) {
        return;
      }

      this.classList.add("open");

      const accordionTarget = getAccordionTarget(card);

      if (!accordionTarget) {
        return;
      }

      injectChildren(card, accordionTarget);
    });
  });

  serviceGrid.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".js-accordion-close");

    if (!closeBtn) {
      return;
    }

    closeAll();
  });
};

function findAccordionAfterCard(card, selector) {
  const serviceSection = card.closest(".service");

  if (!serviceSection) {
    return null;
  }

  const accordions = serviceSection.querySelectorAll(`.js-service__accordion${selector}`);

  return (
    Array.from(accordions).find(accordion => {
      return accordion.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_PRECEDING;
    }) || null
  );
}

servicesInit();
/* ==========================================================================
   Services Accordion
   ========================================================================== */

const scrollToAnchorsInit = function () {
  const navbar = document.querySelector(".navbar");
  const navbarHeight = navbar ? navbar.offsetHeight : 80;

  const anchors = document.querySelectorAll('a[href^="#"]');

  if (!anchors.length) {
    return;
  }

  anchors.forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").substring(1);
      const targetEl = document.getElementById(targetId);

      if (!targetEl) {
        return;
      }

      e.preventDefault();

      const scrollTarget = targetEl.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: scrollTarget - 150,
        behavior: "smooth"
      });
    });
  });
};

scrollToAnchorsInit();

/* ==========================================================================
   Person Experience
   ========================================================================== */

const experienceInit = function () {
  const experienceList = document.querySelector(".experience__links");

  if (!experienceList) {
    return;
  }

  const triggers = experienceList.querySelectorAll(".experience__link");

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      const targetId = this.dataset.target;

      // Desktop: switch active tab
      if (window.innerWidth >= gridSizes.lg) {
        document.querySelectorAll(".experience__tab").forEach(tab => {
          tab.classList.remove("active");
          if (tab.dataset.target === targetId) {
            tab.classList.add("active");
          }
        });
      }

      // Mobile: toggle visible content under heading
      if (window.innerWidth < gridSizes.lg) {
        const mobileContents = experienceList.querySelectorAll(".experience__mobile-content");
        mobileContents.forEach(content => {
          if (content.dataset.target === targetId) {
            content.classList.toggle("is-open");
          } else {
            content.classList.remove("is-open");
          }
        });
      }
    });
  });
};

experienceInit();

/* ==========================================================================
  Animate Figures
   ========================================================================== */
const animateFigures = function () {
  const animatedElements = document.querySelectorAll(".figures-module__figure, .mosaic__text-heading");

  if (!animatedElements) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;

          const fullText = el.textContent.trim();
          const numericValue =
            parseFloat(el.getAttribute("data-figure")) || parseFloat(fullText.replace(/[^\d.]/g, ""));

          if (isNaN(numericValue)) {
            return;
          }

          const prefixMatch = fullText.match(/^[^\d]+/);
          const suffixMatch = fullText.match(/[^\d]+$/);
          const prefix = prefixMatch ? prefixMatch[0] : "";
          const suffix = suffixMatch ? suffixMatch[0] : "";

          const duration = 2000;
          const startTime = performance.now();

          const animate = function (currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const currentValue = Math.floor(progress * numericValue).toLocaleString();

            el.textContent = `${prefix}${currentValue}${suffix}`;

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };

          requestAnimationFrame(animate);

          // Only animate once
          observerInstance.unobserve(el);
        }
      });
    },
    {
      threshold: 0.2 // trigger when 20% visible
    }
  );

  animatedElements.forEach(el => observer.observe(el));
};

animateFigures();

/* ==========================================================================
  Open Search
   ========================================================================== */

const personFiltersInit = function () {
  const personFilters = document.querySelectorAll(".filters filters--person");
  if (!personFilters) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const openParam = urlParams.get("open");

  if (openParam === "person") {
    const filtersContainer = document.querySelector(".filters");

    if (filtersContainer) {
      filtersContainer.classList.add("filters--person", "filters--dropdownopen");
      setTimeout(() => {
        const offset = 100; // Change this value to your header height or desired space
        const elementTop = filtersContainer.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementTop - offset,
          behavior: "smooth"
        });
      }, 200);
    }
  }
};

personFiltersInit();

/* ==========================================================================
  Downwards Arrow
   ========================================================================== */

const heroDownwards = document.querySelector(".hero__downwards");

const scrollToFirstComponent = function () {
  if (!heroDownwards) {
    return;
  }

  heroDownwards.addEventListener("click", function (e) {
    e.preventDefault();

    const firstComponent = document.querySelector(".component");
    if (!firstComponent) {
      return;
    }

    // Calculate scroll position with optional header offset
    const siteheader = document.querySelector(".navbar");
    const headerHeight = siteheader ? siteheader.offsetHeight : 0;

    const targetPosition = firstComponent.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth"
    });
  });
};

scrollToFirstComponent();

/* ==========================================================================
   Scroll Top
   ========================================================================== */

const scrollTopBtn = document.querySelector(".scroll__top");

const scrollTopInit = function () {
  if (!scrollTopBtn) {
    return;
  }

  // Show/hide the button on scroll
  window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
      scrollTopBtn.classList.add("scroll__top--available");
    } else {
      scrollTopBtn.classList.remove("scroll__top--available");
    }
  });

  // Scroll to top on click
  scrollTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
};

scrollTopInit();

/*  ==========================================================================
		NAVIGATION - Anchor Links
		========================================================================== */

const postsAnchor = document.querySelector(".hero__anchors");

const postsAnchorInit = function () {
  if (!postsAnchor) {
    return;
  }

  const anchorLinks = postsAnchor.querySelectorAll(".scrolltolink");

  anchorLinks.forEach(navLink =>
    navLink.addEventListener("click", function (e) {
      e.preventDefault();

      const targetSelector = this.getAttribute("href");
      const targetEl = document.querySelector("#" + targetSelector);

      console.log(targetEl);
      if (!targetEl) {
        return;
      }

      const headerOffset = document.querySelector(".navbar").offsetHeight;
      const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    })
  );
};

postsAnchorInit();

/*  ==========================================================================
		NAVIGATION - Scroll to anchor links if hash
		========================================================================== */

const anchorScrollInit = function () {
  // Get hash without the "#"
  const hash = window.location.hash ? window.location.hash.substring(1) : false;
  if (!hash) {
    return;
  }

  // Find the target element
  const target = document.getElementById(hash);
  if (!target) {
    return;
  }

  // Optional: adjust for sticky header
  const siteHeader = document.querySelector(".navbar");
  const offset = siteHeader ? siteHeader.clientHeight : 0;

  // Scroll after load (ensures layout is ready)
  setTimeout(function () {
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth"
    });
  }, 300);
};

anchorScrollInit();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="44" viewBox="0 0 43 44" fill="none"><g><path d="M43 22L1 22" stroke="#11283F"/><path d="M22 1L0.999996 22L22 43" stroke="#11283F"/></g></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="44" viewBox="0 0 43 44" fill="none"><path d="M0 22H42" stroke="#11283F"/><path d="M21 43L42 22L21 1" stroke="#11283F"/></svg>'
      ],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    window.addEventListener("load", function () {
      setTimeout(() => {
        $(elem).trigger("refresh.owl.carousel");
      }, 200);

      // Optionally trigger global resize too
      window.dispatchEvent(new Event("resize"));
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - navbar-mobile
	========================================================================== */

const mobnav = document.querySelector(".navbar-mobile");
const siteHeaderBd = document.querySelector(".container");
const mobnavToggles = document.querySelectorAll(".navbar-toggle");
const mobnavClose = document.querySelector(".navbar-close");
const mobnavOpenclass = "navbar-mobileopen";

const mobnavInit = function () {
  // Open navbar-mobile on click the toggle
  mobnavToggles.forEach(function (mobnavToggle) {
    mobnavToggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (!body.classList.contains(mobnavOpenclass)) {
        body.classList.add(mobnavOpenclass);
      } else {
        body.classList.remove(mobnavOpenclass);
        // Reset all nav-level panels
        const navPanels = mobnav.querySelectorAll(".nav-level");
        navPanels.forEach(panel => panel.classList.remove("is-active"));

        // Reset trigger active states
        const activeTriggers = mobnav.querySelectorAll(".nav-link--trigger.active");
        activeTriggers.forEach(trigger => trigger.classList.remove("active"));

        // Reset label
        const labelContainer = mobnav.querySelector(".nav-label");
        if (labelContainer) {
          labelContainer.textContent = "";
        }

        // Reset nav state class
        mobnav.className = mobnav.className
          .split(" ")
          .filter(cls => !/^nav-(primary|secondary|tertiary|quaternary)-open$/.test(cls))
          .join(" ")
          .trim();
        mobnav.classList.add("nav-primary-open");

        // Reset navStack
        if (navStack) {
          navStack.length = 0;
          navStack.push("nav-primary");
        }

        // Reactivate primary panel
        const primaryPanel = mobnav.querySelector('[data-nav-id="nav-primary"]');
        if (primaryPanel) {
          primaryPanel.classList.add("is-active");
        }

        // Hide back button
        sharedBackButton.classList.remove("is-visible");
      }
    });
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
	NAVIGATION - Multi Navigation
	========================================================================== */

const navbarMobile = document.querySelector(".navbar-mobile");

const mobileNavInit = function () {
  if (!navbarMobile) {
    return;
  }

  // const navLevels = navbarMobile.querySelectorAll(".nav-level");
  const sharedBackButton = document.getElementById("nav-back-button");

  const navStack = ["nav-primary"]; // initial level

  const setBackButton = () => {
    if (navStack.length > 1) {
      const previous = navStack[navStack.length - 2];
      const previousLevel = previous.split("-")[1]; // e.g. "secondary"
      sharedBackButton.setAttribute("data-nav-back", previous);
      sharedBackButton.setAttribute("data-nav-level", previousLevel);
      sharedBackButton.classList.add("is-visible");
    } else {
      sharedBackButton.classList.remove("is-visible");
    }
  };

  const openNavLevel = (targetId, level, labelText = "", trigger = null) => {
    const targetPanel = navbarMobile.querySelector(`[data-nav-id="${targetId}"]`);
    if (!targetPanel) {
      return;
    }

    // Close any other panels at the same level
    if (level) {
      const levels = ["primary", "secondary", "tertiary", "quaternary"];
      const targetIndex = levels.indexOf(level);

      if (targetIndex >= 0) {
        const deeperPanels = navbarMobile.querySelectorAll(".nav-level");

        deeperPanels.forEach(panel => {
          const panelLevel = panel.getAttribute("data-level");
          const panelIndex = levels.indexOf(panelLevel);

          if (panelIndex >= targetIndex && panel !== targetPanel) {
            panel.classList.remove("is-active");
          }
        });

        // Trim navStack to remove deeper levels
        while (navStack.length > 0) {
          const topLevel = navStack[navStack.length - 1].split("-")[1];
          const topIndex = levels.indexOf(topLevel);
          if (topIndex >= targetIndex) {
            navStack.pop();
          } else {
            break;
          }
        }

        navStack.push(targetId); // Push current panel after trimming
      }
    }

    // Show the target panel
    targetPanel.classList.add("is-active");

    // Add to stack if it's not already top of stack
    if (navStack[navStack.length - 1] !== targetId) {
      navStack.push(targetId);
    }

    setBackButton();

    // Update nav state class (only keep the current level open)
    navbarMobile.className = navbarMobile.className
      .split(" ")
      .filter(cls => !/^nav-(primary|secondary|tertiary|quaternary)-open$/.test(cls))
      .join(" ")
      .trim();
    if (level) {
      navbarMobile.classList.add(`nav-${level}-open`);
    }

    // Update label text
    if (labelText) {
      const labelContainer = navbarMobile.querySelector(".nav-label");
      if (labelContainer) {
        labelContainer.textContent = labelText;
      }
    }

    // Highlight the active trigger
    if (trigger && trigger.classList.contains("nav-link--trigger")) {
      const allTriggers = navbarMobile.querySelectorAll(".nav-link--trigger");
      allTriggers.forEach(t => t.classList.remove("active"));
      trigger.classList.add("active");
    }
  };

  const goBackOneLevel = () => {
    if (navStack.length <= 1) {
      return;
    }

    const currentId = navStack.pop();
    const currentPanel = navbarMobile.querySelector(`[data-nav-id="${currentId}"]`);
    if (currentPanel) {
      currentPanel.classList.remove("is-active");
    }

    const previousId = navStack[navStack.length - 1];
    const previousLevel = previousId.split("-")[1];
    navbarMobile.className = navbarMobile.className
      .split(" ")
      .filter(cls => !/^nav-(primary|secondary|tertiary|quaternary)-open$/.test(cls))
      .join(" ")
      .trim();
    navbarMobile.classList.add(`nav-${previousLevel}-open`);

    setBackButton();

    // Remove active triggers if needed
    const activeTriggers = navbarMobile.querySelectorAll(".nav-link--trigger.active");
    activeTriggers.forEach(trigger => {
      const level = trigger.closest(".nav-level")?.getAttribute("data-level");
      if (level === previousLevel) {
        trigger.classList.remove("active");
      }
    });
  };

  // Init first panel
  const primaryPanel = navbarMobile.querySelector('[data-nav-id="nav-primary"]');
  if (primaryPanel) {
    primaryPanel.classList.add("is-active");
    navbarMobile.classList.add("nav-primary-open");
    setBackButton();
  }

  const navPromo = document.querySelector(".nav-promo");
  // Triggers
  const forwardTriggers = navbarMobile.querySelectorAll("[data-nav-target]");
  forwardTriggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      if (navPromo) {
        navPromo.style.opacity = "0";
        navPromo.classList.add("hide");
      }
      const target = trigger.getAttribute("data-nav-target");
      const level = trigger.getAttribute("data-nav-level");
      const label = trigger.getAttribute("data-nav-label") || "";
      openNavLevel(target, level, label, trigger);
    });
  });

  sharedBackButton.addEventListener("click", goBackOneLevel);
};

mobileNavInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".navbar__search");
const searchToggle = document.querySelector(".search-toggle");
const searchToggleMobile = document.querySelector(".navbar-mobile .search-toggle");
const searchInput = document.querySelector(".navbar__search .searchform__input input");
const searchOpenclass = "search-open";

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("navbar__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) ||
    searchToggle === e.target ||
    searchToggle.contains(e.target) ||
    searchToggleMobile === e.target ||
    searchToggleMobile.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("navbar__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
    if (!body.classList.contains(searchOpenclass)) {
      body.classList.add(searchOpenclass);
    } else {
      body.classList.remove(searchOpenclass);
    }
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  body.classList.remove(mobnavOpenclass);

  if (!body.classList.contains(searchOpenclass)) {
    body.classList.add(searchOpenclass);
  } else {
    body.classList.remove(searchOpenclass);
  }
  if (searchNav.classList.contains("navbar__search--open")) {
    searchNav.classList.remove("navbar__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("navbar__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
  searchToggleMobile.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();


/*  ==========================================================================
				FILTER FUNCTIONS: Used in Stories, Initiatives, in Memoriam
				========================================================================== */

const filters = document.querySelector(".filters");
const filtersToggle = document.querySelector(".filters__dropdownbtn");
const filtersDropdown = document.querySelector(".filters__dropdown");
const filtersForm = document.querySelector(".filters__form");
const filterSearch = document.querySelector(".filters__search");
const filterSearchInput = document.querySelector(".filters__search__input input");
const filterSubmitBtn = document.querySelector(".filters__apply");

// Defines the url for the page that will contain the search results
const filterPageURL = filters ? filters.dataset.filter_url : "";

let currentPageUrl = window.location.href.split("?")[0];

let filtersInitialLoad = true;

/*  ==========================================================================
			 filterGetFormData: Gets selected options from the filter columns
				========================================================================== */

const filterGetFormData = function () {
  let filterData = {};
  let counter = 0;

  if (filter_settings.filters) {
    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");
      if (checkedOptions.length > 0) {
        filterData[el.name] = [...checkedOptions].map(x => x.value);

        counter = counter + checkedOptions.length;
      }
    });
  }

  return filterData;
};

/*  ==========================================================================
			 filterUpdateURL: Updates the url with the selected values
				========================================================================== */

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  // Search parameters
  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = filterPageURL + url_params;

  if (currentPageUrl !== filterPageURL) {
    window.location.href = newUrl;
  }

  if (currentPageUrl === filterPageURL && history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  currentPageUrl = newUrl;
};

/*  ==========================================================================
			 filterAddingActiveTags: Setups up the active tags in the filter bar
			========================================================================== */

const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;

  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Looping throught the filterData
  Object.keys(filterData).forEach(key => {
    const values = filterData[key];

    document
      .querySelector(".filters__fieldset[data-value='" + key + "']")
      .classList.remove("filters__fieldset--active");

    if (values.length > 0) {
      values.forEach(value => {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");

        hasClassActive = true;
      });
    }
  });

  return hasClassActive;
};

/*  ==========================================================================
			 filterGetPosts: Calls the ajax function that retrieve the posts that match
			 the selected filters
				========================================================================== */

const filterGetPosts = function (updateURL = false) {
  console.log("filter");
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData, searchData);
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // Scroll to filtering system
      if (document.querySelector(".filters-pin")) {
        // Adding the height of the siteheader and subnav to the math
        let siteheaderHeight = document.querySelector(".navbar").clientHeight;
        let subnavHeight = 0;
        if (document.querySelector(".subnav")) {
          subnavHeight = document.querySelector(".subnav").clientHeight;
        }

        window.scrollTo({
          top: document.querySelector(".filters-pin").offsetTop - subnavHeight - siteheaderHeight,
          behavior: "smooth"
        });
      }

      // Start filtering
      let loadMore = document.querySelector(".loadmore-container");
      if (loadMore) {
        document.querySelector(".loadmore-container").classList.add("filtering");
      }

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        search: php_variables.search,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          //setFilterTagsListeners();

          //Refreshing animations effects
          setTimeout(function () {
            Waypoint.refreshAll();
          }, 500);

          lazyLoadInstance.update();
        },
        error: function (data) {}
      });
    }
  }
};

/*  ==========================================================================
			 filterCloseDropdown: Closes the dropdown
				========================================================================== */

const filterCloseDropdown = function (lastFocusedElement) {
  if (filters && filtersForm && filters.classList.contains("filters--dropdownopen")) {
    filters.classList.remove("filters--dropdownopen");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }
};

/*  ==========================================================================
			 filterSetupClearAll: Setup Clear all
				========================================================================== */

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");

      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");

      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      window.location.reload();
    });
  });
};

/*  ==========================================================================
			 filterInit: Initialise the filtering functions when there is a filter
			 available
				========================================================================== */

const filterInit = function () {
  if (!filtersForm) {
    return;
  }

  filterGetPosts();

  // Clear all
  filterSetupClearAll();

  const filtersHeading = filters.querySelectorAll(".filters__fieldset-heading");

  const filtersChildren = filters.querySelectorAll(".filters__children__toggle");

  if (filtersChildren) {
    filtersChildren.forEach(function (filterChild) {
      filterChild.addEventListener("click", function (e) {
        e.preventDefault();

        let filterChildWrapper = e.target.closest(".filters__children");
        filterChildWrapper.classList.add("filters__children--active");
      });
    });
  }

  if (filtersHeading) {
    filtersHeading.forEach(function (filterHeading) {
      filterHeading.addEventListener("click", function (e) {
        e.preventDefault();
        let thisFieldset = e.target.closest(".filters__fieldset");
        let isActive = thisFieldset.classList.contains("filters__fieldset--active");

        // Close all fieldsets first
        filtersHeading.forEach(filterHeading2 => {
          let fieldset = filterHeading2.closest(".filters__fieldset");
          fieldset.classList.remove("filters__fieldset--active");
        });

        // If it wasn't already active, open it
        if (!isActive) {
          thisFieldset.classList.add("filters__fieldset--active");
        }
      });
    });
  }

  const filtersOptions = filters.querySelectorAll(
    ".filters__fieldset__field:not(.filters__fieldset__field--notrigger) input"
  );

  let lastFocusedElement = false;

  // Setting up on esc listener if the drowdown is open to close modal
  // and return focus to toggle
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      filterCloseDropdown(lastFocusedElement);
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
      if (!event.target.closest(".filters__dropdown") && !event.target.classList.contains("filters__dropdownbtn")) {
        filterCloseDropdown(lastFocusedElement);
      }
    },
    false
  );

  const cancelBtn = filters.querySelector(".actions__cancel");
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function (e) {
      e.preventDefault();

      filterCloseDropdown(lastFocusedElement);
    });
  }

  // Dropdown open & close
  if (filtersToggle) {
    filtersToggle.addEventListener("click", function (e) {
      e.preventDefault();

      filters.classList.toggle("filters--dropdownopen");
      filtersForm.hidden = false;

      if (filters.classList.contains("filters--dropdownopen")) {
        // Store the last focused element
        lastFocusedElement = document.activeElement;

        // Putting the focus on the first input on the list
        if (filtersOptions && filtersOptions[0]) {
          filtersOptions[0].focus();
        }
      }
      // Setting the aria label for the dropdown
      let aria = filtersToggle.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      filtersToggle.setAttribute("aria-expanded", aria);
    });
  }

  // Filter on submit
  if (filtersForm) {
    filtersForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      let filterData = filterGetFormData();

      // Update url
      filterUpdateURL(filterData);

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.toggle("filters--dropdownopen");
      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }

      // If we are in the search and it's mobile close filter options
      if (filterSearch) {
        filterSearch.classList.remove("open");
      }
    });
  }

  filtersOptions.forEach(option => {
    option.addEventListener("change", function (evt) {
      // Set up for checkbox group that only admits one item checked at the time
      if (this.dataset.type && this.dataset.type === "single") {
        let name = this.getAttribute("name");

        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input[name=" + name + "]");
        filterCheckboxes.forEach(el => {
          if (el !== this) {
            el.checked = false;
          }
        });
      }

      if (!filterSubmitBtn) {
        // Call the filtering post function
        filterGetPosts(true);
      }

      // Close the filters dropdown
      filterCloseDropdown(lastFocusedElement);
    });
  });

  if (filterSubmitBtn) {
    // Setting up event listener to trigger the filter
    filterSubmitBtn.addEventListener("click", function (e) {
      // Call the filtering post function
      filterGetPosts();
      filters.classList.toggle("filters--dropdownopen");
    });
  }
};

filterInit();

const filterDropdownInit = function () {
  const filterFieldsets = document.querySelectorAll(".insights__filter .filters__fieldset");

  if (!filterFieldsets.length) {
    return;
  }

  filterFieldsets.forEach(fieldset => {
    const heading = fieldset.querySelector(".filters__fieldset-heading");
    const fields = fieldset.querySelector(".filters__fieldset__fields");

    heading.addEventListener("click", function () {
      fieldset.classList.toggle("filters__fieldset--active");
    });

    // Optional: close when clicking outside
    document.addEventListener("click", function (e) {
      if (!fieldset.contains(e.target)) {
        fieldset.classList.remove("filters__fieldset--active");
      }
    });
  });
};

filterDropdownInit();

// const homepageFilterRedirectInit = function () {
//   const form = document.querySelector(".people-search .filters__form");

//   if (!form) {
//     return;
//   }

//   const getFormParams = function () {
//     const inputs = form.querySelectorAll('input[type="search"], input[type="radio"]:checked');
//     const params = new URLSearchParams();

//     inputs.forEach(input => {
//       const value = input.value.trim();
//       if (value) {
//         params.append(input.name, value);
//       }
//     });

//     return params;
//   };

//   form.addEventListener("submit", function (e) {
//     e.preventDefault();

//     const baseUrl = form.dataset.filterPageUrl;
//     const url = new URL(baseUrl);
//     const params = getFormParams();

//     console.log(baseUrl + " " + url);

//     // window.location.href = `${url.pathname}?${params.toString()}`;
//   });
// };

// homepageFilterRedirectInit();

const liveSearch = function () {
  const inputs = document.querySelectorAll(".filters__search__input input, .searchform__input input");
  if (!inputs.length) {
    return;
  }

  const handleInput = function (e) {
    const input = e.target;
    const wrapper = input.closest(".filters, .searchform") || document;

    const suggestionsBox = wrapper.querySelector(".suggestions");

    if (!suggestionsBox) {
      return;
    }

    const query = input.value.trim();

    if (query.length < 2) {
      suggestionsBox.innerHTML = "";
      suggestionsBox.classList.add("hidden");
      return;
    }

    fetch(`/wp-admin/admin-ajax.php?action=live_search&term=${encodeURIComponent(query)}`)
      .then(response => response.json())
      .then(data => {
        suggestionsBox.innerHTML = "";

        if (!data.length) {
          suggestionsBox.classList.add("hidden");
          return;
        }

        data.forEach(post => {
          const li = document.createElement("li");
          li.innerHTML = `<a href="${post.link}" class="block px-4 py-3 hover:bg-gray-100 text-dark-green transition rounded-lg">${post.title}</a>`;
          suggestionsBox.appendChild(li);
        });

        suggestionsBox.classList.remove("hidden");
      });
  };

  const handleOutsideClick = function (e) {
    document.querySelectorAll(".suggestions").forEach(box => {
      if (!box.contains(e.target) && !Array.from(inputs).some(input => input.contains(e.target))) {
        box.innerHTML = "";
        box.classList.add("hidden");
      }
    });
  };

  inputs.forEach(input => {
    input.addEventListener("input", handleInput);
  });

  document.addEventListener("click", handleOutsideClick);
};

liveSearch();
